import Modal from "@mui/material/Modal";
import { useCallback, useState } from "react";
import { Carousel } from "react-responsive-carousel";

import { IContractProps } from "../../models";
import { MainDetailsHeading } from "./MainDetailsHeadding";
import styles from "./styles.module.scss";

export const MainDetails = ({ contract, unAuthenticated }: IContractProps) => {
  const [showSlider, setShowSlider] = useState(false);

  const openGalleryPreview = useCallback(() => {
    if (
      contract?.itemDetail?.images &&
      contract?.itemDetail?.images?.length > 0
    ) {
      setShowSlider(true);
    }
  }, [contract?.itemDetail?.images]);

  return (
    <div className={styles.container}>
      <div className={styles.image_container}>
        <img
          onClick={openGalleryPreview}
          alt="complex"
          className={styles.itemDetailImage}
          src={
            contract?.itemDetail?.images &&
            contract?.itemDetail?.images?.length > 0
              ? contract?.itemDetail?.images[0]
              : "/assets/images/svg/contract_blank.svg"
          }
        />
      </div>
      <div className={styles.text_container}>
        {contract && (
          <MainDetailsHeading
            unAuthenticated={unAuthenticated}
            contract={contract}
          />
        )}
      </div>
      {contract?.itemDetail?.images && (
        <Modal
          open={showSlider}
          onClose={() => setShowSlider(!showSlider)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <span className={styles["container_wrapper_carousel"]}>
            <Carousel
              autoPlay={true}
              showThumbs={false}
              showIndicators={true}
              dynamicHeight={true}>
              {contract?.itemDetail?.images &&
                contract?.itemDetail?.images?.map((image, index) => (
                  <div className={styles["container_wrapper_div"]} key={index}>
                    <img
                      src={image}
                      className={styles["container_wrapper_img"]}
                    />
                  </div>
                ))}
            </Carousel>
          </span>
        </Modal>
      )}
    </div>
  );
};
